module.exports = __webpack_public_path__ + "img/sixpackcarrier82.726779b5.jpg";